/**
 * Short-circuits possible infinite values when dividing by zero
 */
const safeAverage = (total: number, count: number): number => {
  return total / count || 0;
};

export default safeAverage;
